import { useBreakpointValue, useMediaQuery } from 'native-base';
import { Platform } from 'react-native';

import { isNative, isWeb } from 'utils/environment';

export const useIsMobileBreakpoint = (): boolean => {
  if (isNative) {
    // we treat tablet native as mobile always now so avoid expensive evaluation
    return true;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useBreakpointValue({
    base: true,
    md: false,
  });
};

export const useIsExtraSmallBreakpoint = (): boolean => {
  const [isExtraSmall] = useMediaQuery({
    maxWidth: 350,
  });

  return Boolean(isExtraSmall);
};

/**
 * This is a hook to check if the screen height is less than 640px.
 * This is a workaround to fix the issue with the map view not being visible on some devices.
 * @returns boolean
 */
export const useIsLowHeightDevice = (): boolean => {
  const [isSmallHeight] = useMediaQuery({
    maxHeight: 700,
  });

  return Boolean(isSmallHeight);
};

/** note: this will be TRUE for tablets in the APP in some cases.
 * If used incorrectly with pixel values like `margin: 20px` directly to components
 * it will cause native android crashes. Consider useIsDesktopWebBreakpoint to guarantee web.*/
export const useIsDesktopBreakpoint = (): boolean => {
  if (isNative) {
    // we treat tablet native as mobile always now so avoid expensive evaluation
    return false;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useBreakpointValue({
    base: false,
    md: true,
  });
};

export const useIsDesktopWebBreakpoint = (): boolean => {
  return (
    isWeb &&
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useBreakpointValue({
      base: false,
      md: true,
    })
  );
};

/** only use if outside of normal app providers as this won't re-render on resize */
export const getEarlyIsDesktopWebBreakpoint = (): boolean => {
  if (isNative) {
    // we treat tablet native as mobile always now so avoid expensive evaluation
    return false;
  }

  return typeof window !== 'undefined' && window.innerWidth > 962;
};

export const useIsDesktopLargeBreakpoint = (): boolean => {
  if (isNative) {
    // we treat tablet native as mobile always now so avoid expensive evaluation
    return false;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useBreakpointValue({
    base: false,
    lg: true,
  });
};

export const getIsMobileWeb = (): boolean => {
  if (Platform.OS !== 'web') {
    return false;
  }

  return !!(
    typeof navigator !== 'undefined' &&
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  );
};
